import { render } from "./dssInfoText.vue?vue&type=template&id=96a54e48&scoped=true"
const script = {}

import "./dssInfoText.vue?vue&type=style&index=0&id=96a54e48&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96a54e48"]])

export default __exports__